 import React,{useState} from "react";
 import Breadcrumb from '../Components/Breadcrumb'
import Pagehelmet from '../Components/Pagehelmet'
import { useLocation } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
 const Form  = () =>{
      const [error, setError] = useState(null);
      const [success, setSuccess] = useState(false);
    
      const navigate = useNavigate();
     const location = useLocation();
  const { formData, registrationResponse } = location.state || {};

  const { 
    email,
    firstName,
    lastName,
    phone,
    role,
    address,             
    emergencyContact,    
    preferences,         
    familyMembers,
    password,
  } =  formData  || {};

  console.log(email,'email otp')

  console.log(formData,'formData otp')
  const [Data, setFormData] = useState({
    otp:""
  })
  console.log(Data['otp'],'Data otp')


 const headers = {
    Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
  };

  const url = `${process.env.REACT_APP_API_URL}/users/signup-otp`

  const [loading, setLoading] = useState(false);

const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

 
    try {
      setLoading(true);

      // Prepare the data to send
      const payload = {
         email,
    firstName,
    lastName,
    phone,
    role,
    address,             
    emergencyContact,    
    preferences,         
    familyMembers,
    password,

    otp:Data['otp']

      };

      // Remove confirmpassword as it's not needed in the API call
     

      const response = await axios.post(url, payload, { headers });

      if (response.data) {
        setSuccess(true);
        // Redirect or show success message

 localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("email", response.data.email || "");
        localStorage.setItem(
          "User_Info",
          JSON.stringify(response.data.userId || {})
        );
        localStorage.setItem("token", response.data.token || "");






        setTimeout(() => {
          navigate('/ ', {
            state: {  // Correct property name is 'state' not 'formData'
              formData: formData,
              registrationResponse: response.data // Include API response if needed
            }
          });
        }, 2000);


      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError(err.response?.data?.message || 'An error occurred during registration');
    } finally {
      setLoading(false);
    }
  }
    return(
        <div>
   <div>
      <Pagehelmet pageTitle="Sign Up" />
      <Breadcrumb title="Sign Up Now" />

      {/*--Book now Section start*/}
      <section className="ticket-booking">
        <div className="container">
          <div className="booking-form w-lg-75 m-auto px-2">
            <div className="form-title mb-4">
              <h2 className="mb-2"><span className="pink">Place </span> One Time Password</h2>
              <p>Place Otp To Finish sign Up</p>
            </div>
            <div className="form-content">
              <form onSubmit={handleSubmit} className="max-w-3xl mx-auto p-4">
                {/* Error and Success Messages */}
                {error && (
                  <div className="alert alert-danger mb-4">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="alert alert-success mb-4">
                    OTP successful! Redirecting...
                  </div>
                )}

                {/* Student Information */}
                <div className="row mb-4">
                  <h6 className="text-xl font-semibold mb-3">One Time Password</h6>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="otp" className="block mb-2">OTP</label>
                    <input
                      type="number"
                      id="otp"
                      value={formData.otp}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>
              

            
 

               

              
              

               
                </div>

                <div className="text-left mt-6">
                  <button
                    className="btn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Processing...' : 'Submit Otp'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
        </div>
    )
 }
 export default  Form